<template>
  <div class='coursework-viewer__comment-panel'>
    <!-- HEADER -->
    <div class='coursework-viewer__comment-panel_header'>
      <div class='coursework-viewer__comment-panel_header_row'>
        <div class='coursework-viewer__comment-panel_header_user'>
        </div>
        <div class='coursework-viewer__comment-panel_header_add'>
          <a class='kd-btn--sm btn--prim btn--outline' v-if="!replying" @click="reply" :tabindex="is_open ? '' : '-1'" v-focus="is_open">Add Comment</a>
        </div>
      </div>
      <comment-editor v-if="!mobile_view && replying" @persist="create" @cancel="replying = false" :class="{'is-open': replying}"/>
    </div>

    <!-- SORT -->
    <div class='coursework-viewer__comment-panel_sort'>
      <a href="javascript:" class='coursework-viewer__comment-panel_sort-btn' @click="sort_by = 'newest'" :class="{'is-selected': sort_by === 'newest'}" :tabindex="is_open ? '' : '-1'">Newest</a>
      <a href="javascript:" class='coursework-viewer__comment-panel_sort-btn' @click="sort_by = 'oldest'" :class="{'is-selected': sort_by === 'oldest'}" :tabindex="is_open ? '' : '-1'">Oldest</a>
      <a href="javascript:" class='coursework-viewer__comment-panel_sort-btn' @click="sort_by = 'likes'" :class="{'is-selected': sort_by === 'likes'}" :tabindex="is_open ? '' : '-1'">Most Likes</a>
      <div class='coursework-viewer__comment-panel_num-comments' v-if="threadComments.length > 0">
        {{ `${threadComments.length} ${'Comment'.pluralize(threadComments.length)}` }}
      </div>
    </div>

    <!-- COMMENT LISTING -->
    <div class='coursework-viewer__comment-panel_content' v-if="threadComments.length > 0">
      <comment-thread v-for="comment in threadComments" @removed="updateCommentCount" :current_user="current_user" :mobile_view="mobile_view" :is_open="is_open"
                      :comment_thread="comment" :comments_path="media.comments_path" :key="comment.id"/>

      <div class='view-more' v-html="meta && meta.paginator"></div>
    </div>

    <!-- NO COMMENT PLACEHOLDER -->
    <div class='coursework-viewer__comment-panel_content' v-if="threadComments.length === 0">
      <div class='section-alert p2'>
        <div class='section-alert__icon'>
        </div>
        <h4 class='section-alert__title'>No comments (yet)</h4>
        <p class='section-alert__description'>Let's start a conversation!</p>
        <a class='btn--md btn--prim' @click="reply">Add Comment</a>
      </div>
    </div>

    <!-- COMMENT MODAL (MOBILE) -->
    <comment-modal v-if="mobile_view && replying" :current_user="current_user" @persist="create" @cancel="replying = false"/>
  </div>
</template>

<script>
  import commentThread from './comment-thread.vue'
  import commentEditor from './comment-editor.vue'
  import commentModal from './comment-modal.vue'
  export default {
    props: {
      media: Object,
      current_user: Object,
      show_comment_modal: Boolean,
      mobile_view: Boolean,
      is_open: Boolean
    },
    components: {
      commentThread,
      commentEditor,
      commentModal,
    },
    data() {
      return {
        replying: false,
        meta: {},
        comments: [],
        sort_by: 'newest'
      }
    },
    computed: {
      threadComments() {
        return _.filter(this.comments, function(comment) { return !comment.deleted; })
      }
    },
    watch: {
      is_open() {
        if (this.is_open) {
          this.fetchComments();
        }
      },
      media() {
        if (this.is_open) {
          this.fetchComments();
        }
      },
      sort_by() {
        this.fetchComments();
      },
      show_comment_modal() {
        this.replying = this.show_comment_modal
      },
      replying() {
        if (this.mobile_view && !this.replying) {
          this.$emit('hideCommentModal')
        }
      }
    },
    methods: {
      makeRequest: (url, loadingIndicator) => {
        return new Kadenze.AjaxRequest({
          type: 'GET',
          url: url,
          loadingIndicator: loadingIndicator
        });
      },
      fetchComments(url) {
        url = url || Kadenze.Util.insertURLParam(this.media.comments_path, 'sort', this.sort_by);
        const response = this.makeRequest(url, {container: this.$el, positionTop: 'absolute'});
        response.done((response) => {
          this.meta = response.meta;
          this.comments = response.comments;
          this.$nextTick(() => {
            Kadenze.PaginationBinding.applyBindingsWithTextInput(this.fetchComments.bind(this));
          });
        });
      },
      reply() {
        this.$parent.loginOrRegister().done(() => {
          this.replying = true
        });
      },
      create(content) {
        let params = {
          content: content,
          commentable_id: this.media.id,
          commentable_type: this.media.type
        };
        let request = new Kadenze.AjaxRequest({
          url: this.media.comments_path,
          data: { thread_comment: params }
        });

        request.done((response) => {
          this.comments.unshift(JSON.parse(response.thread_comment));
          this.replying = false;
          this.updateCommentCount();
        });

        request.fail((xhr, status, msg) => {
          new Kadenze.Notice.error({ message: xhr.responseJSON.message });
        });
      },
      updateCommentCount() {
        this.media.comment_count = this.threadComments.length;
        this.$emit('commentCountChanged')
      }
    },
    mounted() {
      if (this.is_open) {
        this.fetchComments();
      }
    }
  }
</script>